<template>
  <el-button @click="issue()" type="text" style="flex:1">I</el-button>
</template>

<script>
// import mdl from "~/mixins/mdl";
// import { mapActions, mapGetters } from "vuex";
import * as api from "~/api/resource";
// import _ from "lodash";
export default {
  name: "s-invoice-issuer",
  data() {
    return {
      loading: false
    };
  },
  props: {
    value: { type: Object, default: () => null },

    className: { type: String, default: "Booking" }
  },
  watch: {
    // extraQueryParams: {
    //   handler: function(newValue) {
    //     const qStamp = JSON.stringify(newValue);
    //     if (qStamp != this.cachedRemoteQ) {
    //       this.cachedRemoteQ = qStamp;
    //       this.remoteSearch();
    //     }
    //   },
    //   deep: true
    // },
  },
  computed: {},
  async created() {
    // _log_("change sel.", this.optionsRepo);
    // if (this.optionsRepo && this.loadRepo) {
    //   const r = await this.fetch(this.optionsRepo);
    // }
    // // await this.remoteSearch();
    // if (this.value) this.cvalue = this.value + "";
    // _log_("CREATE sel.", this.cvalue);
  },
  methods: {
    async issue() {
      let qo = {};
      qo.className = this.className;
      qo.relId = this.value.id;
      const data = await api.fetchProcessor("gears/issueinvoice", qo);
      _log_("CREATE issue.", data);
    }
  },
  async mounted() {}
};
</script>

<style>
.largefit .el-input__inner {
  height: auto !important;
  line-height: 42px !important;
}
.largefit .el-input--suffix .el-input__inner {
  padding-right: auto !important;
}
.el-select.prefixed span.el-input__prefix {
  right: 0px;
}
</style>
